import { dataChartStarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChartStarSolid = /*#__PURE__*/createIcon(dataChartStarSolid)
export default IconChartStarSolid
